import * as React from 'react';
import { Theme } from '@mui/material';
import { WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';
import { Category, ProductApi, Languages } from 'common/types';
import TextField from '@mui/material/TextField';
import { getActiveCategories } from 'common/utils/newRentalUtils';
import MenuItem from '@mui/material/MenuItem';
import { getTranslation } from 'common/modules/translations';
import { useTranslation } from 'services/localization/useTranslation';

interface OwnProps {
	categories: Category[];
	stockProducts: ProductApi[];
	selectedCategoryId: string;
	lang: Languages;
	handleSelectedCategoryIdChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

type Props = OwnProps & WithStyles<typeof styles>;

export const CategorySelector = (props: Props) => {
	const {
		classes,
		categories,
		stockProducts,
		selectedCategoryId,
		lang,
		handleSelectedCategoryIdChange,
	} = props;
	const activeCategories = getActiveCategories(categories, stockProducts);
	const { t } = useTranslation();
	return (
		<TextField
			id="categoryId"
			name="categoryId"
			className={classes.categorySelector}
			select
			value={selectedCategoryId || ''}
			onChange={handleSelectedCategoryIdChange}
			SelectProps={{
				displayEmpty: true,
				autoWidth: true,
				classes: {
					select: classes.categorySelect,
				},
			}}
			InputLabelProps={{
				shrink: true,
			}}
			InputProps={{
				disableUnderline: true,
			}}
			margin="none"
			type="text"
			variant="standard"
		>
			<MenuItem value="all">{t('newRental.showAllProducts', 'Show all products')}</MenuItem>
			{activeCategories.map((category) => (
				<MenuItem value={category.id} key={category.id}>
					{getTranslation(category.name, lang)}
				</MenuItem>
			))}
		</TextField>
	);
};

const styles = (theme: Theme) =>
	createStyles({
		categorySelector: {
			overflow: 'hidden',
		},
		categorySelect: {
			padding: '8px 16px',
			paddingLeft: 0,
		},
	});

export default withStyles(styles)(CategorySelector);
